import { isActivePeriod, isFuturePeriod } from './dateTime';
import { type BudgetDefinition } from '../budgets-by-dimensions/hooks/budgetDefinition';
import { type BudgetaryExercise } from '../models/budgetaryExercise';

export const compareBudgetsV2ByStatus = (
  a: BudgetDefinition,
  b: BudgetDefinition,
) => {
  return (
    getBudgetPriority({ startDate: a.period.start, endDate: a.period.end }) -
    getBudgetPriority({ startDate: b.period.start, endDate: b.period.end })
  );
};

export const compareBudgetsV1ByStatus = (
  a: BudgetaryExercise,
  b: BudgetaryExercise,
) => {
  return getBudgetPriority(a) - getBudgetPriority(b);
};

const getBudgetPriority = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}) => {
  if (isActivePeriod({ start: startDate, end: endDate })) {
    return 0;
  }
  if (isFuturePeriod({ start: startDate, end: endDate })) {
    return 1;
  }
  return 2;
};
